import { HostBinding, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: `suka-page-header`,
  template: `
    <suka-breadcrumb *ngIf="breadcrumb"></suka-breadcrumb>

    <suka-stack
      alignment="center"
    >
      <div sukaStackItem fill="true">
        <ng-container *ngIf="!isTemplate(title)">
          <h3 class="page__header__title">{{title}}</h3>
          <span *ngIf="subtitle" class="page__header__subtitle">{{subtitle}}</span>
        </ng-container>

        <ng-template *ngIf="isTemplate(title)" [ngTemplateOutlet]="title"></ng-template>
      </div>

      <ng-template [ngTemplateOutlet]="actions"></ng-template>
    </suka-stack>
  `
})
export class PageHeader {
  @HostBinding('class.page__header') baseClass = true;

  @Input() title: string | TemplateRef<any>;

  @Input() subtitle: string;

  @Input() actions: TemplateRef<any>;

  @Input() breadcrumb = true;

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }
}
